import styled from "styled-components";

import { Button } from "./primitives";

const MASCOT = "https://racccoin.org/raccmascot_anim.webp";

const Wrap = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 20px;
`;

const MascotWrap = styled.div`
  position: relative;
  margin-bottom: 6px;
`;

const Glow = styled.div`
  position: absolute;
  inset: -14px;
  background: radial-gradient(circle, ${({ theme }) => theme.color.accentGlow} 0%, transparent 62%);
  filter: blur(10px);
  opacity: 0.6;
`;

const Mascot = styled.img`
  position: relative;
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: saturate(0.6) brightness(0.9);
`;

const Title = styled.div`
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

const Body = styled.div`
  margin-top: 8px;
  max-width: 260px;
  font-size: 13px;
  line-height: 1.45;
  color: ${({ theme }) => theme.color.textDim};
`;

const Badge = styled.div`
  margin-top: 20px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.color.surfaceAlt};
  border: 1px dashed ${({ theme }) => theme.color.borderHi};
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 11px;
  color: ${({ theme }) => theme.color.textFaint};

  span {
    color: ${({ theme }) => theme.color.accent};
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 300px;
  margin-top: 26px;
`;

const Mono = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 16px;
`;

export function EmptyChats({
  onBrowse,
  onAddToGroup,
}: {
  onBrowse: () => void;
  onAddToGroup: () => void;
}) {
  return (
    <Wrap>
      <MascotWrap>
        <Glow />
        <Mascot src={MASCOT} alt="Rocky" />
      </MascotWrap>

      <Title>No chats yet</Title>
      <Body>
        You haven&rsquo;t joined any chats with Rocky. Add the bot to a group or hop into a public
        one to start raising a raccoon together.
      </Body>

      <Badge>
        <span>›</span> opened from DM · no chat context
      </Badge>

      <Actions>
        <Button $variant="primary" $full onClick={onBrowse}>
          <Mono>⌕</Mono> browse public chats
        </Button>
        <Button $variant="ghost" $full onClick={onAddToGroup}>
          <Mono>+</Mono> add Rocky to a group
        </Button>
      </Actions>
    </Wrap>
  );
}
